<!--
 * @Author: wjw this.wujiwen@gmail.com
 * @Date: 2022-10-26 14:23:46
 * @LastEditors: wjw this.wujiwen@gmail.com
 * @LastEditTime: 2024-05-14 15:22:10
 * @FilePath: \unidt\src\components\visitingCard.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="visiting-card">
    <div
      class="visiting-card-item-box"
      v-for="(item, index) in data"
      :key="`visiting-card-item${index}`"
    >
      <van-row>
        <van-col span="16">
          <div class="visiting-card-item-department">{{ item.department }}</div>
          <div class="visiting-card-item-name">{{ item.name }}</div>
          <div class="visiting-card-item-position" v-if="item.position">
            {{ item.position }}
          </div>
        </van-col>
        <van-col span="8" class="visiting-card-item-vxbox">
          <img :src="item.vx" alt="企业微信" class="visiting-card-item-vx" />
        </van-col>
      </van-row>
      <van-row v-if="item.mail">
        <div class="visiting-card-item-mail">
          <img :src="icon_mail" alt="邮箱" />
          <span>{{ item.mail }}</span>
        </div>
      </van-row>
    </div>
  </div>
</template>
<script>
import icon_mail from "@/../static/img/product/icon_mail.png";
export default {
  data() {
    return {
      icon_mail
    };
  },
  props: {
    data: {
      type: Array,
      default: () => []
    }
  }
};
</script>
<style lang="less" scoped>
.visiting-card {
  .visiting-card-item-box {
    padding: 32px;
    background: linear-gradient(127deg, #ffffff 0%, #f8f8fe 100%);
    border: 2px solid #e6e7ed;
    margin: 48px 0;
    .visiting-card-item-position {
      display: flex;
      align-items: center;
      height: 160px;
      font-size: 24px;
      color: #08204d;
      line-height: 44px;
    }
    .visiting-card-item-department {
      font-size: 24px;
      color: #08204d;
      line-height: 34px;
    }
    .visiting-card-item-name {
      font-size: 32px;
      color: #08204d;
      line-height: 44px;
    }
    .visiting-card-item-vxbox {
      text-align: right;
      .visiting-card-item-vx {
        width: 160px;
        height: 160px;
      }
    }
    .visiting-card-item-mail {
      display: flex;
      align-items: center;
      font-size: 28px;
      font-weight: 500;
      color: #08204d;
      line-height: 48px;
      margin-top: 36px;
      > img {
        width: 48px;
        height: 48px;
        margin-right: 8px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/visitingCard.vue